export default __webpack_public_path__ + "static/media/mobile_manual.4fc50f40.png";